// extracted by mini-css-extract-plugin
export default {"checkItem":"HistoryModal_checkItem__ZGy4f","button":"HistoryModal_button__aHOwS","modal":"HistoryModal_modal__-Rz2J"};